import { render, staticRenderFns } from "./CarouselPostsMobile.vue?vue&type=template&id=33469c7e&scoped=true"
import script from "./CarouselPostsMobile.vue?vue&type=script&lang=js"
export * from "./CarouselPostsMobile.vue?vue&type=script&lang=js"
import style0 from "./CarouselPostsMobile.vue?vue&type=style&index=0&id=33469c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33469c7e",
  null
  
)

export default component.exports